import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;
export const Button = styled.div`
  cursor: pointer;
  width: 95px;
  height: 35px;
  outline: 1px solid #d0cfd3;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-weight: bold;
  background: #fff;

  ${(props) =>
    props.isActive &&
    css`
      outline-color: #333;
      color: #333;
      z-index: 10;
    `}
`;
